import { render, staticRenderFns } from "./ItemCollectionDetailUtility.vue?vue&type=template&id=62de745a&scoped=true&"
import script from "./ItemCollectionDetailUtility.vue?vue&type=script&lang=js&"
export * from "./ItemCollectionDetailUtility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62de745a",
  null
  
)

export default component.exports